import React from 'react'
import { Link } from 'react-router-dom'
import './pagenotfound.scss'
import { useTranslation } from 'react-i18next'

const PageNotFound = (props) => {
  const { t } = useTranslation()

  return (
    <div className="page-not-found">
      <h1>{t('page_not_found')}</h1>
      <div>
        {t('return_to_the')} <Link to="/">{t('homepage')}</Link>
      </div>
    </div>
  )
}

export default PageNotFound
